var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStationaryTesting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FE8839;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000169543457747929418920000004515786093377993095_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "gps",
    className: "st0",
    d: "M136.9,41.3h52.2v17.4h-52.2V41.3z M415.2,250c0,56-87.5,143.8-104.4,160.2V452 c0,22.9-18.6,41.5-41.5,41.5H56.7c-22.9,0-41.5-18.6-41.5-41.5V48c0-22.9,18.6-41.5,41.5-41.5h212.7c22.9,0,41.5,18.6,41.5,41.5 v71.9c-2.9-0.3-5.7-0.4-8.7-0.4c-3,0-5.8,0.1-8.7,0.4v-17.7H32.6V452c0,13.3,10.8,24.1,24.1,24.1h212.7 c13.3,0,24.1-10.8,24.1-24.1l0,0v-36.8H50v-17.4h231.2c-29.6-30.6-92-100.6-92-147.9c0-62.5,50.6-113.1,113.1-113.1 S415.3,187.6,415.2,250L415.2,250z M32.6,84.8h260.9V48c0-13.3-10.8-24.1-24.1-24.1c0,0,0,0,0,0H56.7c-13.3,0-24.1,10.8-24.1,24.1 V84.8z M397.8,250c0.5-52.8-41.9-96.1-94.8-96.6c-52.8-0.5-96.1,41.9-96.6,94.8c0,0.6,0,1.2,0,1.8c0,41.4,64.3,113.4,95.7,144.5 C333.6,363.4,397.8,291.3,397.8,250L397.8,250z M363.1,250c0,33.6-27.3,60.9-60.9,60.9c-33.6,0-60.9-27.3-60.9-60.9 s27.3-60.9,60.9-60.9S363.1,216.3,363.1,250C363.1,250,363.1,250,363.1,250L363.1,250z M345.7,250c0-24-19.5-43.5-43.5-43.5 c-24,0-43.5,19.5-43.5,43.5s19.5,43.5,43.5,43.5c0,0,0,0,0,0C326.2,293.5,345.6,274,345.7,250L345.7,250z M328.3,104.6v17.6 C389,134.6,432.6,188,432.6,250H450C450,178.5,398.7,117.2,328.3,104.6z M328.3,69.3v17.6c80.1,12.9,139.1,82,139.1,163.2h17.4 C484.7,159.3,418.1,82.3,328.3,69.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStationaryTesting);
export default __webpack_public_path__ + "static/media/Stationary Testing.cfb0fc7b5a06b5e37e443f5af3969b4a.svg";
export { ForwardRef as ReactComponent };